module.exports = __webpack_public_path__ + "static/media/localeur_logo.ca7533c7.svg";